import { Component, EventEmitter, Input, Output } from '@angular/core';

import { HisUiService, HisNotificationService, GenericValue } from 'hisng';
import { ResearchPartnerWrapperUtils } from 'app/fs/res/common/utils/researchPartner-wrapper-utils';
import { ResearchPartnerService } from 'app/fs/res/common/service/researchPartner/researchPartner.service';
import { ResearchPartner, ResearchPartnerSimple } from 'app/fs/res/common/model/researchPartner/researchPartner';

@Component( {
    selector: 'res-external-organization-create-dialog',
    templateUrl: './external-organization-create-dialog.component.html'
} )
export class ExternalOrganisationCreateDialogComponent {
    @Input() visibility = false;
    @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter();
    @Output() saveDialogChange: EventEmitter<ResearchPartnerSimple> = new EventEmitter();

    public researchPartner: ResearchPartner = new ResearchPartner();
    public researchPartners: GenericValue[] = [];

    constructor( private hisUiService: HisUiService,
        private notificationService: HisNotificationService,
        private researchPartnerService: ResearchPartnerService ) { }

    /* close dialog action */
    closeDialog() {
        this.notificationService.clear();
        this.visibilityChange.emit(false);
    }

    /* save dialog action */
    saveDialog() {
        this.notificationService.clear();

        // Save Service Call
        this.researchPartnerService.saveResearchPartner( this.researchPartner ).subscribe( (savedResearchPartnerId: number) => {
            if ( savedResearchPartnerId != null ) {
                // set return id of saved researchPartner
                this.researchPartner.id = savedResearchPartnerId;
                // save success - info message changes after save
                this.notificationService.infoI18n( 'de.his.javang.gefunden.change' );
                this.saveDialogChange.emit(
                    ResearchPartnerWrapperUtils.transformToResearchPartnerSimple( this.researchPartner )
                );
            }
        } );
    }
}
